import React, { Component } from 'react';
import { ListTabButton } from '../../../../common/list-tab/list-tab-button.component';
import { Selected_Index, PrimarySecondaryString } from '../../../../../constants/external-constants';
import PrimaryOrderCircuit from './primary-order-circuit.component';
import SecondaryOrderCircuit from './secondary-order-circuit.component';
import OrderCircuit from '../order-circuit/order-circuit.component';

class WirelineOrderCircuit extends Component {
    constructor(props) {
        super(props);
        this.state={
            selectedIndex: 0,
            listTab: [
                {
                    "id": Selected_Index.i_Zero,
                    "label": "Primary Circuit",
                    "hidden": false
                },
                {
                    "id": Selected_Index.i_One,
                    "label": "Secondary Circuit",
                    "hidden": false,
                    "disable": false
                },
            ]
        }
    }

    handleFilterIndex=(index)=>{
        this.setState({selectedIndex: parseInt(index)});
    }

    handleActiveListTab = (listTab) => {
        const { disputeDetailsId, item } = this.props;

        return listTab.map(item => {
            var disabled = item.disable;
            if ((item.id == Selected_Index.i_One || item.id == Selected_Index.i_Two) && disputeDetailsId > 0) {
                disabled = false;
            }

            return {
                ...item,
                disable: disabled
            };
        })
    }

    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    render() {
        const {...props} = this.props;
        const {listTab, selectedIndex} = this.state;
        return(
            <div>
                {
                    listTab && this.props.ranking == this.capitalizeFirstLetter(PrimarySecondaryString.both) ?
                    <div className='mt-4'>
                        <ListTabButton listData={this.handleActiveListTab(listTab)} selectedIndex={selectedIndex} FilterIndex={this.handleFilterIndex} />
                        {selectedIndex === parseInt(Selected_Index.i_Zero) && <PrimaryOrderCircuit {...props} ranking={this.capitalizeFirstLetter(PrimarySecondaryString.primary)}/>}
                        {selectedIndex === parseInt(Selected_Index.i_One) && <SecondaryOrderCircuit {...props} ranking={this.capitalizeFirstLetter(PrimarySecondaryString.secondary)}/>}
                    </div>
                    :
                    <div>
                        <OrderCircuit {...props} />
                    </div>
                }
            </div>
        )
    }
}

export default WirelineOrderCircuit;